<template>
  <div class="FormAuthProfile">
    <el-form v-loading="loadingPage" :model="ruleForm" ref="ruleForm" :rules="rules" @submit.prevent v-on:submit.prevent>
      <HeaderPage>
        <el-button style="height: 44px; margin-left: 1rem" native-type="submit" @click.prevent="submitForm('ruleForm')">
          Salvar
        </el-button>
        <el-dropdown v-if="ruleForm.id" trigger="click" @command="handleAction">
          <el-button type="text" icon="el-icon-more" class="el-dropdown-link"></el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item icon="el-icon-delete" command="DELETE">Excluir</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </HeaderPage>
      <el-card shadow="never" style="background-color: transparent; border: 0;">
        <el-row :gutter="20">
          <el-col :lg="12" :sm="12" :xs="24">
            <el-card style="margin-top: 0; min-height: 100%;">
              <el-descriptions :title="'Configuar Perfil de acesso'" />
              <el-row :gutter="20">
                <el-col :sm="24" :xs="24">
                  <el-form-item prop="type_account_id" label="Tipo da Conta">
                    <el-select v-model="ruleForm.type_account_id" clearable style="width: 100%">
                      <el-option v-if="$can('1')" :label="'Admin'" :value="1" />
                      <el-option v-if="$can('1')" :label="'Marketplace'" :value="2" />
                      <el-option v-if="$can('1')" :label="'Representante'" :value="4" />
                      <el-option v-if="$can('1|2|4|5|6')" :label="'Estabelecimento Comercial'" :value="5" />
                      <el-option v-if="$can('1')" :label="'Gerente de Marketplace'" :value="6" />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :sm="24" :xs="24">
                  <el-form-item prop="name" label="Nome" :error="error.name">
                    <el-input size="large" v-model="ruleForm.name" required></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-card>
          </el-col>
          <el-col :lg="12" :sm="12" :xs="24">
            <el-card style="margin-top: 0; min-height: 100%;">
              <el-descriptions :title="'Permissões de acesso'" />
              <div class="boxfees">
                <el-collapse>
                  <el-collapse-item
                      v-for="(permissionsList, key) in listPermissions"
                      :key="key"
                      :title="key"
                      :name="key"
                  >
                    <el-row :gutter="20">
                      <el-col
                          style="display: flex; align-items: center; justify-content: space-between; margin-bottom: .9rem;"
                          :sm="24"
                          :xs="24"
                      >
                        <label for="all">Selecionar todas as permissões</label>
                        <el-switch
                            v-on:change="handleChangeStatusPermission(`all-${key}`)"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            :active-value="true"
                            :inactive-value="false"
                            :value="checkAllSelection(key)"
                        >
                        </el-switch>
                      </el-col>
                      <el-col
                          v-for="(permission) in permissionsList"
                          :key="permission.id"
                          style="display: block; height: auto; margin-bottom: .7rem;"
                          :sm="24"
                          :xs="24"
                      >
                        <div style="display: flex; align-items: center; justify-content: space-between;">
                          <label :for="permission.id">{{ permission.name }}</label>
                          <el-switch
                              v-on:change="handleChangeStatusPermission(permission.key)"
                              active-color="#13ce66"
                              inactive-color="#ff4949"
                              :active-value="true"
                              :inactive-value="false"
                              :value="ruleForm.permissions.includes(permission.key)"
                          >
                          </el-switch>
                        </div>
                        <label style="font-size: small; display: flex; color: #8c939d">
                          {{ permission.description }}
                        </label>
                      </el-col>
                    </el-row>
                  </el-collapse-item>
                </el-collapse>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </el-card>
    </el-form>
  </div>
</template>

<script>
import {clearRuleForm, makeErrorFilds} from "@/app/plugins/utils";
import {
  deleteCardBrand,
  getPermissions,
  getProfiles,
  postProfile,
  putCardBrand, putProfile
} from "@/app/domains/Config/services";
import HeaderPage from "@/app/components/HeaderPage";

export default {
  name: "FormAuthProfile",
  components: {
    HeaderPage,
  },
  data () {
    return {
      loadingPage: false,
      listPermissions: [],
      error: {},
      ruleForm: {
        name: '',
        type_account_id: '',
        permissions: [],
      },
      rules: {
        name: [
          {required: true, message: 'Requerido', trigger: 'blur'}
        ],
        type_account_id: [
          {required: true, message: 'Requerido', trigger: 'blur'}
        ],
      },
    }
  },
  computed: {
    isEdit: function () {
      return !!(this.ruleForm.id)
    },
  },
  methods: {
    handleChangeStatusPermission(i) {
      let permissionKey = i.split('-')[0];

      if(permissionKey === 'all') {
        if (this.ruleForm.permissions.includes(i)) {
          let group = i.split('-')[1];

          this.listPermissions[group].forEach((permission) => {
            this.ruleForm.permissions.splice(permission.key, 1);
          })

        } else {
          let group = i.split('-')[1];

          this.listPermissions[group].forEach((permission) => {
            if (!this.ruleForm.permissions.includes(permission.key)) {
              this.ruleForm.permissions.push(permission.key);
            }
          })
        }
      } else if (this.ruleForm.permissions.includes(permissionKey)) {
        this.ruleForm.permissions = this.ruleForm.permissions.filter(p => p !== i);
      } else {
        this.ruleForm.permissions.push(i);
      }
    },
    async init () {
      if (this.$route.params.id !== undefined) {
        this.loadingPage = true
        try {
          let response = await getProfiles(`/${this.$route.params.id}`)
          this.ruleForm = clearRuleForm(response.data)
          this.ruleForm.permissions = this.ruleForm.permissions.map(permission => permission.key);
        } catch (e) {
          console.log(e);
          this.error = makeErrorFilds(e)
          this.$message({
            showClose: true,
            message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
            type: 'error'
          })
          await this.$router.push({name: 'config.auth_profile.index'})
        } finally {
          this.loadingPage = false
        }
      }
    },
    checkAllSelection (permissionGroup) {
      let counterPermissions = this.listPermissions[permissionGroup].length;
      let counterSelected = 0;

      this.listPermissions[permissionGroup].forEach((permission) => {
        if (this.ruleForm.permissions.includes(permission.key)) {
          counterSelected++;
        }
      })

      return counterSelected >= counterPermissions;
    },
    handleAction (ruleForm) {
      this.$confirm('Deseja excluir este Bandeira?', 'Atenção', {
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        center: true,
        type: 'warning'
      }).then(async () => {
        this.loadingPage = true
        this.error = {}
        try {
          let response;
          // let query = this.$route.meta.pathAPI + '/' + this.ruleForm.id
          response = await deleteCardBrand('/' + this.ruleForm.id)
          await this.$router.push({name: 'config.cardbrand.index'})
          this.$message({
            showClose: true,
            message: 'Excluido',
            type: 'success'
          })
        } catch (e) {
          this.error = makeErrorFilds(e)
          this.$message({
            showClose: true,
            message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
            type: 'error'
          })
        } finally {
          this.loadingPage = false
        }
      }).catch(() => {
      });
    },
    submitForm (ruleForm) {
      this.$refs[ruleForm].validate(async (valid) => {
        if (valid) {
          this.error = {}
          this.loadingPage = true
          try {
            let response;
            if (this.ruleForm.id !== undefined) {
              response = await putProfile(this.ruleForm.id, clearRuleForm(this.ruleForm))
              await this.$router.push({name: 'config.auth_profile.index'})
              this.$message({
                showClose: true,
                message: 'Perfil de acesso editado com Sucesso',
                type: 'success'
              })
            } else {
              response = await postProfile(this.ruleForm)
              await this.$router.push({name: 'config.auth_profile.index'})
              this.$message({
                showClose: true,
                message: 'Perfil de acesso criado com sucesso',
                type: 'success'
              })
            }
          } catch (e) {
            this.error = makeErrorFilds(e)
            this.$message({
              showClose: true,
              message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
              type: 'error'
            })
          } finally {
            this.loadingPage = false
          }
        }
      })
    },
    async fetchPermissions() {
      try {
        this.loadingPage = true;
        const response = await getPermissions();
        this.listPermissions = response.data;

        let array = [];
        let keys = Object.keys(response.data);

        [...Object.values(response.data)].forEach((item, key) => {
          array[keys[key]] = item;
        });

        array.forEach((listPermissions) => {
          console.log(listPermissions);
          listPermissions.forEach((permission, key) => {
            this.ruleForm.permissions[key] = {
              status: 'inactive',
            }
          })
        })
      } catch (e) {
        console.log(e);
        this.error = makeErrorFilds(e)
        this.$message({
          showClose: true,
          message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
          type: 'error'
        })
      } finally {
        this.loadingPage = false
      }
    }
  },
  async mounted() {
    await this.init();
    await this.fetchPermissions();
  }
}
</script>

<style scoped>

</style>
